import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import banner1 from "../assets/transparencia/inversiones/inversiones1.jpg";
import banner2 from "../assets/transparencia/inversiones/inversiones2.jpg";
import banner3 from "../assets/transparencia/inversiones/inversiones3.jpg";

import "./Matricula.css"; // reutiliza tu mismo CSS institucional

const Inversiones = () => {
  const [index, setIndex] = useState(0);

  const banners = [banner1, banner2, banner3];

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // 🔁 Cambia las imágenes automáticamente cada 4 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [banners.length]);

  return (
    <section className="gestion-page">
      {/*  Banner superior */}
      <div className="info-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Inversiones y Recursos Económicos</h1>
          <p className="lead">
            Transparencia sobre la gestión financiera y las inversiones institucionales.
          </p>
        </div>
      </div>

     
      <div className="container py-5">
        <div className="row align-items-center">
        
          <div className="col-lg-5 col-md-12" data-aos="fade-right">
            <h2 className="section-subtitle mb-4">Inversiones</h2>
            <p className="text-muted">
              No se cuenta con inversiones en los últimos años.
            </p>

            <h2 className="section-subtitle mb-4 mt-5">Reinversiones</h2>
            <p className="text-muted">
              No se cuenta con inversiones en los últimos años.
            </p>

            <h2 className="section-subtitle mb-4 mt-5">Donaciones</h2>
            <p className="text-muted">
              No se cuenta con inversiones en los últimos años.
            </p>

            <h2 className="section-subtitle mb-4 mt-5">Obras de infraestructura</h2>
            <p className="text-muted">
              No se cuenta con inversiones en los últimos años.
            </p>
          </div>

        
          <div className="col-lg-7 col-md-12 mt-5 mt-lg-0" data-aos="fade-left">
            <div className="mini-slider-container">
              {banners.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Inversión ${i + 1}`}
                  className={`mini-slide ${i === index ? "active" : ""}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inversiones;
